// Domain redirect - runs before React mounts
if (window.location.hostname === 'upbeatmoon.com' || window.location.hostname === 'www.upbeatmoon.com') {
  window.location.replace(`https://sabaimran.com${window.location.pathname}${window.location.search}${window.location.hash}`);
}

/* eslint-disable import/first */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css';
import App from './App';
/* eslint-enable import/first */

// Ensure the element with ID 'root' exists
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}
